(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name dashboard.controller:DashboardCtrl
     *
     * @description
     *
     */
    angular
        .module('dashboard')
        .controller('DashboardCtrl', DashboardCtrl);

    function DashboardCtrl($rootScope, $log, $state, $translate, CTLocalizationService, AccountsService, PaymentTemplatesService,
        QuickPaymentModalService, TimelineService, HelperService, EInvoiceDocumentsService,
        TransactionsService, MessagesService, DashboardWidgetModalService, CurrencyService,
        $timeout, PaymentsService, $sessionStorage, $q, ImagesService,
        NotificationCountService, LoyaltyPointsService, $filter, $window, AlertService, ViberService, base64, GoogleTagManagerHelperService) {
        var vm = this;
        vm.localCurrency = $rootScope.APP_GLOBAL_SETTINGS.defaultData.DefaultCurrency;
        vm.countryCode = $rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation;
        vm.recompile = {
            timeline: true
        };

        vm.currencySelectObject = {};
        vm.currenciesList = [];
        vm.currenciesFilter = {
          pageSize: 1000
        };


        vm.currentLang = '';
        if(vm.countryCode === 'hr' || vm.countryCode === 'bh'){
          vm.currentLang = $translate.proposedLanguage() || $translate.use();
          $rootScope.$on('appLanguageChangedNavigation', function (evt, lang) {
            if (lang && lang.langCode) {
              vm.currentLang = $translate.proposedLanguage() || $translate.use();
              console.log("lang", vm.currentLang);
            }
          });
          $rootScope.$on('appLanguageChangedHeader', function (evt, lang) {
            if (lang && lang.langCode) {
              vm.currentLang = $translate.proposedLanguage() || $translate.use();

              console.log("lang", vm.currentLang);
            }
          });
        }

        vm.periodList = [
            {
                item: {
                    key: 'today',
                    description: 'core.period.today'
                }
      },
            {
                item: {
                    key: 'yesterday',
                    description: 'core.period.yesterday'
                }
      }, {
                item: {
                    key: 'thisWeek',
                    description: 'core.period.thisWeek'
                }
      }, {
                item: {
                    key: 'thisMonth',
                    description: 'core.period.thisMonth'
                }
      }
    ];

        if(vm.countryCode !== 'sl'){
          vm.periodList.push({
            item: {
              key: 'thisYear',
              description: 'core.period.thisYear'
            }
          });
        }

      vm.periodList.push({
        item: {
          key: 'all',
          description: vm.countryCode === 'sl' ? 'core.period.last6Months' : 'core.period.all'
        }
      });

        vm.selectedPeriod = vm.periodList[3];

        vm.timelineTimeFilter = function (item) {
            vm.selectedPeriod = item;
            appendTimeRangeTlFilter();
            vm.resetTimelineFilter();
            vm.timelineFilter.itemTypeList = null;

            if(vm.countryCode === 'sl')
              vm.timelineFilter.currency = vm.currencySelectObject.symbol;

            vm.getTimelineItemsGrouped(true);

            GoogleTagManagerHelperService.pushEvent('Dashboard', 'TabPeriodFilter', $translate.instant(vm.selectedPeriod.item.description));

        };

        vm.getDateFromDatestring = function (datestring) {
            return new Date(datestring);
        };

        vm.getGroupDateTitle = function (tlItem) {
            var date = new Date(tlItem.date);
        };

        vm.tmpSearchText = {
            name: ''
        };

        vm.showFavoriteTemplates = true;
        vm.showTemplatesView = false;
        vm.toggleTemplatesView = function () {

            vm.showTemplatesView = !vm.showTemplatesView;

            if (vm.showTemplatesView === true) {

                if (!vm.templateList.result || vm.templateList.result.length === 0) {
                    vm.getPaymentTemplatesPage();
                }

                $timeout(function () {
                    var searchTemplatesInput = angular.element('#searchTemplatesInput');
                    searchTemplatesInput.focus();
                }, 500);
            }
        };

        vm.toggleFavoriteTemplates = function (searchValue) {

            if (searchValue != '') {
                vm.showFavoriteTemplates = false;
            } else {
                vm.showFavoriteTemplates = true;
            }
        };

        vm.changeLanguage = function (langKey) {
            CTLocalizationService.setLanguage(langKey);
        };

        vm.accountsFilter = {
            page: 0,
            pageSize: 1000,
            isFavorite: true,
            includeList: ['loanAccount']
        };

        // account filter for BiH environment
        if (vm.countryCode === 'bh') {
            vm.accountsFilter.orderBy = 'accountType';
        } else {
            vm.accountsFilter.orderBy = 'accountType, iban';
        }

        vm.templatesFilter = {
            page: 0,
            pageSize: 1000
        };
        vm.timelineFilter = {
            page: 0,
            amountGTE: null,
            amountLTE: null,
            orderBy: 'date desc',
            pageSize: 10
        };

        var appendTimeRangeTlFilter = function () {
            var timeRange = HelperService.getDateRange(vm.selectedPeriod.item.key);
            if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation === 'sl' && vm.selectedPeriod.item.key === 'all') {
                timeRange = HelperService.getDateRange('6months');
            }
            vm.timelineFilter.dateGTE = timeRange.valueDateGTE;
            vm.timelineFilter.dateLTE = timeRange.valueDateLTE;
        };

        appendTimeRangeTlFilter();
        vm.busy = false;

        vm.accountList = {};
        vm.accountListAll = {};
        vm.templateList = {};
        vm.timelineList = {};
        vm.timelineListGrouped = {};

      function showPaymentsReturnInfo() {
        var filter = {
          page: 0,
          orderBy: 'dateCreated DESC',
          status: 'Opened',
          pageSize: 15,
          paymentTypeGroupList: 'SEPARecall'
        };
        PaymentsService.getPage(filter)
          .then(function (response) {
            if(response.result && response.result.length > 0){
              $sessionStorage.paymentsReturnInfoViewed =true;
              AlertService.paymentsReturnInfo();

            }
          })
          .catch(function (error) {
            $log.error(error);
          });
      }

      vm.init = function () {

            if ($rootScope.APP_GLOBAL_SETTINGS.defaultData) {
                vm.defaultData = $rootScope.APP_GLOBAL_SETTINGS.defaultData;
                vm.countryCode = vm.defaultData.APILocation;
            }

            if ($rootScope.APP_GLOBAL_SETTINGS.userSettings) {
                vm.userSettings = $rootScope.APP_GLOBAL_SETTINGS.userSettings;
                // console.log("USEEEEERR", vm.userSettings);
            }

            // getNotificationsCount();
            vm.getAccountsPage(true);
            //vm.getAccountsPageAll();
            loadBannerImages();

          if (vm.countryCode == 'sl') {
            vm.getLoyaltyPointsPage();
          }

          if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.SyncEnabled && $rootScope.APP_GLOBAL_SETTINGS.defaultData.SyncEnabled == 'false') {
              vm.getTimelineItemsGrouped(true);
          } else {
            // Sync timeline to ensure that timeline is up to date
            syncTimeline().then(function () {
              vm.getTimelineItemsGrouped(true);
            });
          }

          vm.getExchangeListPage();

          if(vm.countryCode == 'hr' && !$sessionStorage.paymentsReturnInfoViewed){
            showPaymentsReturnInfo();
          }

        };



        var syncTimeline = function () {
            return TimelineService.syncTimeline()
                .then(function (response) {
                    $rootScope.APP_GLOBAL_SETTINGS.loginInfo = response[0];
                    console.log("Synced: ");
                }).catch(function (error) {
                    console.log("Error: " + error);
                });
        };

        vm.loadMoreAccounts = function () {
            vm.getAccountsPage(false);
        };

        vm.loadMoreTimelineItemsGrouped = function () {
            vm.getTimelineItemsGrouped(false);
        };

        vm.getAccountsPage = function (reset) {
            if (vm.busy) return;
            vm.busy = true;
            if (reset) {
                vm.accountsFilter.page = 0;
            } else {
                vm.accountsFilter.page += 1;
            }

            if (vm.accountList.hasMore || vm.accountsFilter.page === 0) {
                AccountsService.getPage(vm.accountsFilter)
                    .then(function (response) {
                        if (!reset) {
                            vm.accountList.hasMore = response.hasMore;
                            vm.accountList.result = vm.accountList.result.concat(response.result);
                        } else {
                            vm.accountList = response;
                        }

                        if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
                            sortAccountsForSloDashboard();
                        }
                        vm.busy = false;
                        $log.debug(vm.accountList);
                    })
                    .catch(function (error) {
                        $log.error(error);
                    });
            }
        };

        function sortAccountsForSloDashboard() {
            vm.currentAndCreditAccounts = [];
            vm.loanAccounts = [];
            vm.depositAccounts = [];
            vm.savingAccounts = [];
            vm.giroAccounts = [];

            if (vm.accountList.result.length !== 0) {
                _.forEach(vm.accountList.result, function (value) {
                    if (value.accountType.group === 'CardAccountTypes' || value.accountType.group === 'CurrentAccount') {
                        vm.currentAndCreditAccounts.push(value);
                    } else if (value.accountType.group === 'LoanAccountType') {
                        vm.loanAccounts.push(value);
                    } else if (value.accountType.group === 'DepositAccountTypes') {
                        vm.depositAccounts.push(value);
                    } else if (value.accountType.group === 'SavingAccountTypes') {
                        vm.savingAccounts.push(value);
                    } else if (value.accountType.group === 'GiroAccount') {
                        vm.giroAccounts.push(value);
                    }
                });
                vm.currentAndCreditAccounts = $filter('orderBy')(vm.currentAndCreditAccounts, ['-accountType.group', '-isOwn', 'sortOrderId'])
                vm.depositAccounts = $filter('orderBy')(vm.depositAccounts, ['-isFavorite', '-isOwn', '-accountType.group'])
                vm.savingAccounts = $filter('orderBy')(vm.savingAccounts, ['-isFavorite', '-isOwn', '-accountType.group'])
            }
        }

        vm.getAccountsPageAll = function () {
            var deferred = $q.defer();
            AccountsService.getAll()
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (error) {
                    $log.error(error);
                    deferred.reject(error);
                });
            return deferred.promise;
        };

        vm.getPaymentTemplatesPage = function () {
            // if(vm.countryCode == 'sl'){
            //   vm.templatesFilter = {
            //     paymentTypeGroupList: ['DomesticPayment','LocalCurrencyTransfer','ForeignPayment']
            //   }
            // }

            PaymentTemplatesService.getPage(vm.templatesFilter)
                .then(function (response) {
                        vm.templateList = response;
                        $log.debug(vm.templateList);
                    }
                    /*, function (error) {
                     console.log(error);
                     }*/
                )
                .catch(function (error) {
                    $log.error(error);
                });

        };

        // vm.markedLastLogin = false;
        vm.getTimelineItemsGrouped = function (reset) {
            if (reset) {
                vm.timelineFilter.page = 0;
            } else {
                vm.timelineFilter.page += 1;
            }
            console.log(vm.timelineFilter);

            var searchFilter = angular.extend(vm.timelineSearchFilter, vm.timelineFilter);

            TimelineService.getPage(vm.timelineSearchFilter)
                .then(function (response) {
                    $(response.result).each(function (i, e) {
                        if (e.itemType == "TransactionCredit") {
                            e.credit = e.amount;
                            e.debit = null;
                        } else if (e.itemType == "TransactionDebit") {
                            e.credit = null;
                            e.debit = e.amount;
                        } else {
                            e.credit = null;
                            e.debit = null;
                        }
                    });

                    vm.timelineListGrouped = HelperService.mergeRowsForTimeline({
                        existingData: vm.timelineListGrouped,
                        newData: response,
                        groupFunction: function (item) {
                            var date = new Date(item.date);
                            // If we want to group only by date component, without hours
                            date.setHours(0, 0, 0, 0);
                            return date;
                        },
                        virtualRowFunction: function (e) {
                            var month = new Date(e).getMonth() + 1;
                            var day = new Date(e).getDate();
                            var virtualRow = {
                                isVirtual: true,
                                date: e,
                                month: month,
                                day: day
                            };
                            $log.debug("virtualRow", e, virtualRow);
                            return virtualRow;
                        },
                        reset: reset,
                        reverse: false
                    });

                    var todayDateRange = HelperService.getTodayWithoutOffset();
                    var yesterdayDateRange = HelperService.getYesterdayWithoutOffset();


                    _.forEach(vm.timelineListGrouped.result, function (item) {
                        item.dateValue = new Date(item.date);
                        if (item.dateValue >= todayDateRange.firstDay && item.dateValue <= todayDateRange.lastDay) {
                            item.showText = true;
                            item.dateLabel = 'core.period.today';
                        } else if (item.dateValue >= yesterdayDateRange.firstDay && item.dateValue < yesterdayDateRange.lastDay) {
                            item.showText = true;
                            item.dateLabel = 'core.period.yesterday';
                        } else {
                            item.showDate = true;
                        }
                    });

                    // Timeline items are sorted by date descending. Find first login item in results list and mark it as last login item.
                    var lastLoginItem = _.find(vm.timelineListGrouped.result, function (item) {
                        return item.itemType === 'LoginSuccessful';
                    });
                    if (lastLoginItem) {
                        lastLoginItem.lastLogin = true;
                    }

                    $log.debug("groupedTimeline", vm.timelineListGrouped);
                    //alert(2);
                    vm.recompile.timeline = true;
                }).catch(function (error) {
                    $log.error(error);
                });
        };

        vm.gotoAccount = function (accountId) {
            $state.go('accounts', {
                accountId: accountId
            });
        };
        vm.gotoAccountFromTimelineSearch = function (timelineItemId) {
            var temp = timelineItemId.split('_');
            var accountId = temp[1];


            $state.go('accounts', {
                accountId: accountId
            });
        };

        vm.gotoEInvoiceFromTimelineSearch = function (timelineItemId) {
            $state.go('eInvoices.detail', {
                eInvoiceId: timelineItemId
            });
        };

        vm.openQPModal = function () {
            QuickPaymentModalService.openQPModal();

        };

        vm.navigateToPaymentForm = function (templateParams) {
          if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl" && templateParams.template.paymentSubTypeGroup == "NotSupportedPayment") {
            AlertService.infoAlert({
              text: "paymentsOverview.notSupportedPaymentMsg"
            })
            return;
          }
            var stateLink;
            var params = {
                templateId: templateParams.id
            };
            var template = templateParams.template;
            //var strObj = JSON.stringify({
            //  id: templateParams.id,
            //  type: 'template'
            //});
            switch (templateParams.type) {
            case "LocalCurrencyTransfer":
                stateLink = "payments.internalTransfer.fromTemplate";
                if (vm.countryCode == 'sl') {
                    stateLink = "payments.domesticPayment.fromTemplatesToPay";
                }
                break;
            case "ForeignCurrencyTransfer":
                stateLink = "payments.internalTransfer.fromTemplate";
                break;
            case "DomesticPayment":
            case "SEPAPayment":
            case "RevenuePayment":
                stateLink = "payments.domesticPayment.fromTemplate";
                if (vm.countryCode == 'sl') {
                    stateLink = "payments.domesticPayment.fromTemplatesToPay";
                }
                break;
            case "CurrencyExchange":
                stateLink = "payments.currencyConversion.fromTemplate";
                break;
            case "ForeignPayment":
                stateLink = "payments.internationalPayment.fromTemplate";
                if (vm.countryCode == 'sl') {
                    stateLink = "payments.internationalPayment.fromTemplatesToPay";
                }
                break;
            }


          if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') {
            // AccountsService.getAccountById(template.accountId)
            //   .then (function (response) {
            //     angular.extend (template, response);
                // if (template.paymentTypeGroup == "LocalCurrencyTransfer" && (template.toAccountNumber.substring(0, 4) != "SI56" || template.fromAccountNumber.substring(0, 4) != "SI56")) {
                //   stateLink = 'payments.internalTransfer.fromTemplate';
                // } else if (template.paymentTypeGroup == "LocalCurrencyTransfer" && template.toAccountNumber.substring(0, 4) == "SI56") {
                //   stateLink = 'payments.domesticPayment.fromTemplate'
                // }


                if (template.paymentTypeGroup == "LocalCurrencyTransfer" && template.paymentSubTypeGroup == "SEPAPayment") {
                  stateLink = 'payments.domesticPayment.fromTemplate';
                } else if (template.paymentTypeGroup == "LocalCurrencyTransfer"  && template.paymentSubTypeGroup == "LocalCurrencyTransfer") {
                  stateLink = 'payments.internalTransfer.fromTemplate';
                }


              // }).finally(function () {
              if (stateLink) {
                $state.go(stateLink, params);
              }
            // })

          } else {
            if (stateLink) {
              $state.go(stateLink, params);
            }
          }
        };

        vm.getTransactionDetails = function (timelineItem) {
            if (timelineItem.selected) {
                TransactionsService.getById(timelineItem.referenceId)
                    .then(function (response) {
                        timelineItem.transaction = response;
                        if (response.accountId) {
                            AccountsService.getAccountById(response.accountId)
                                .then(function (response) {
                                    timelineItem.account = response;
                                })
                                .catch(function (error) {
                                    $log.error(error);
                                })
                        }
                    })
                    .catch(function (error) {
                        HelperService.showMessage(error, 'error');
                    });
            }
        };

        vm.getEinvoiceDetails = function (timelineItem) {
            EInvoiceDocumentsService.getById(timelineItem.referenceId)
                .then(function (response) {
                    if (response) {
                        timelineItem.einvoiceDetails = response;
                    }
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        };

        vm.getMessageDetails = function (timelineItem) {
            var id;
            if (timelineItem.referenceType == 'Payment') {
                id = timelineItem.id.split('_')[0];
            } else {
                id = timelineItem.referenceId;
            }

            if (timelineItem.selected) {
                MessagesService.getById(id)
                    .then(function (response) {
                        timelineItem.messageDetails = response;
                    })
                    .catch(function (error) {
                        HelperService.showMessage(error, 'error');
                    });
            }
        };

        vm.openPayment = function (paymentId) {
            PaymentsService.downloadPaymentPdf(paymentId);
        };

        vm.formatText = function (text) {
            return HelperService.formatResponseBody(text, false);
        };

        vm.searchInputExpanded = true;
        vm.searchFilterExpanded = false;

        vm.showSearchResultWrapper = false;

        vm.expandSearch = function () {
            vm.timelineFilter.itemType = '';
            vm.resetTimelineFilter();


            if (vm.searchInputExpanded === false && vm.searchFilterExpanded === false) {
                vm.searchInputExpanded = !vm.searchInputExpanded;
                vm.searchFilterExpanded = !vm.searchFilterExpanded;

                $timeout(function () {
                    var searchTimelineInput = angular.element('#searchTimelineInput');
                    searchTimelineInput.focus();
                }, 500);

            } else if (vm.searchInputExpanded === true && vm.searchFilterExpanded === true) {
                vm.searchInputExpanded = !vm.searchInputExpanded;
                vm.searchFilterExpanded = !vm.searchFilterExpanded;
                vm.getTimelineItemsGrouped(true);

            } else if (vm.searchInputExpanded === true && vm.searchFilterExpanded === false) {
                vm.searchInputExpanded = !vm.searchInputExpanded;
                vm.getTimelineItemsGrouped(true);

            } else if (vm.searchInputExpanded === false && vm.searchFilterExpanded === true) {
                vm.searchFilterExpanded = !vm.searchFilterExpanded;

            }
        };

        vm.toggleFilterSelection = function () {
            vm.searchFilterExpanded = !vm.searchFilterExpanded;
            vm.timelineSearchFilter.descriptionFTS = '';

            if (vm.searchFilterExpanded && vm.currenciesList.length === 0) {
                // Load currencies only when user opens filter
                vm.getExchangeListPage();
            }
        };

        vm.timelineItemTypeSelected = 1;

        vm.selectTimelineItemType = function (type) {
            switch (type) {
            case "all":
                vm.timelineFilter.itemTypeList = null;
                vm.timelineItemTypeSelected = 1;
                break;
            case "credit":
                vm.timelineFilter.itemTypeList = ['TransactionCredit'];
                vm.timelineItemTypeSelected = 2;
                break;
            case "debit":
                vm.timelineFilter.itemTypeList = ['TransactionDebit'];
                vm.timelineItemTypeSelected = 3;
                break;
            case "others":
                vm.timelineFilter.itemTypeList = ['MessageIn', 'MessageOut', 'EInvoice', 'LoginSuccessful', 'LoginFailed'];
                vm.timelineItemTypeSelected = 4;
                break;
            default:
                vm.timelineFilter.itemTypeList = null;
                vm.timelineItemTypeSelected = 1;

            }
          // $translate.instant(vm.selectedPeriod.item.description)
          GoogleTagManagerHelperService.pushEvent('Dashboard', 'TimelineFilterCategorySelection', $translate.instant("timelineFilter." + type));

          vm.resetTimelineFilter();
            //vm.getTimelineItemsGrouped(true)

        };

        vm.resetTimelineFilter = function () {
            vm.timelineFilter.amountGTE = null;
            vm.timelineFilter.amountLTE = null;
            vm.timelineFilter.currency = null;
            vm.timelineSearchFilter.descriptionFTS = "";
            setDefaultCurrencyOnFilter();
        };
        vm.applyTimelineFilter = function () {
            console.log(vm.timelineFilter);
            if (vm.timelineFilter.amountGTE || vm.timelineFilter.amountLTE) {
                vm.timelineFilter.currency = vm.currencySelectObject.symbol;
            }

            if(vm.countryCode === 'sl'){
              vm.timelineFilter.currency = vm.currencySelectObject.symbol;
            }

            $log.debug("timelineFiler", vm.timelineFilter);
            vm.getTimelineItemsGrouped(true);
            vm.searchFilterExpanded = false;
            // vm.numberOfPendingPaymentsToShow = 0;
        };

        vm.openWidgetsModal = function () {
            vm.getAccountsPageAll()
                .then(function (response) {
                    vm.accountListAll = response;
                    DashboardWidgetModalService.openDashboardWidgetModal(vm.accountListAll).then(function (closed) {
                            if (closed) {
                                vm.getAccountsPage(true);
                            }
                        })
                        .catch(function (error) {
                            HelperService.showMessage(error, 'error');
                        });
                });

            GoogleTagManagerHelperService.pushEvent('Dashboard', 'FavoritesButton', 'Favorites button clicked');
        };

        vm.timelineSearchFilter = {
            descriptionFTS: '',
            pageSize: 20,
            orderBy: 'date DESC'
        };
        vm.timelineSearchResult = [];
        vm.getTimelineSearchPage = function () {
            TimelineService.getPage(vm.timelineSearchFilter)
                .then(function (response) {

                    vm.timelineSearchResult = response.result;

                    if (vm.timelineSearchResult.length !== 0) {
                        vm.showSearchResultWrapper = true;
                        vm.searchFilterExpanded = false;
                    } else {
                        vm.showSearchResultWrapper = false;
                        vm.searchFilterExpanded = false;
                    }

                    $log.debug("timeline search result", response);
                    vm.recompile.timeline = true;
                }).catch(function (error) {
                    $log.error(error);
                });
        };


      function setDefaultCurrencyOnFilter() {
        if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') {
          vm.currencySelectObject = vm.currenciesList[0];
        } else {
          vm.currencySelectObject = _.find(vm.currenciesList, function (item) {
            return item.symbol === vm.localCurrency;
          });
        }
      }

      vm.getExchangeListPage = function () {

            CurrencyService.getCurrencyPage(vm.currenciesFilter)
                .then(function (response) {
                    vm.currenciesList = response.result;
                    if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') {
                      vm.currenciesList.unshift({code: "", symbol: ""});
                    }
                  setDefaultCurrencyOnFilter();
                    //$log.debug("currenciesList", vm.currenciesList);
                }).catch(function (error) {
                    $log.error(error);
                });

        };

        //GET PENDING PAYMENTS
        vm.pendingPaymentsFilter = {
            page: 0,
            status: null,
            statusList: ['InProcessing', 'WaitingQueue'],
            orderBy: 'dateCreated DESC',
            pageSize: 10
        };
        if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") {
            vm.pendingPaymentsFilter.pageSize = 100;
        }

        if (vm.countryCode == 'sl')
            vm.pendingPaymentsFilter.statusList = ['InProcessing', 'WaitingQueue', 'Opened'];

        vm.pendingPaymentsList = {};
        vm.getPendingPaymentsPage = function () {

            PaymentsService.getPendingPayments(vm.pendingPaymentsFilter)
                .then(function (response) {
                    vm.pendingPaymentsList = response;
                    vm.pendingPaymentsOpened = true;
                    $log.debug("pendingPaymentsList", vm.pendingPaymentsList);
                })
                .catch(function (error) {
                    $log.error(error);
                });
        };

        vm.showPendingPayments = function () {
            if (!vm.pendingPaymentsList.result || vm.pendingPaymentsList.result.length === 0) {
                vm.getPendingPaymentsPage();
            } else {
                vm.pendingPaymentsOpened = true;
            }
        };

        vm.hidePendingPayments = function () {
            vm.pendingPaymentsOpened = false;
        };

        vm.recallPaymentAction = function (paymentId) {
            var params = {
                id: paymentId
            };
            PaymentsService.recallPayment(params)
                .then(function (response) {
                    vm.getPaymentsPage(true);
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                })
        };

        vm.signPaymentAction = function (paymentId) {
            PaymentsService.openSignModal(paymentId)
                .then(function (signed) {
                    if (signed) {
                        vm.getPaymentsPage(true);
                    }
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        };

        vm.deletePaymentAction = function (paymentId) {
            PaymentsService.deletePayment(paymentId)
                .then(function (response) {
                    HelperService.deleteInformationMsg(['core.paymentOrder', 'core.successDelete'], paymentId);
                    vm.getPaymentsPage(true);
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
        };

      vm.showNotificationsPanel = ($sessionStorage.hasOwnProperty("showNotificationsPanel")) ? $sessionStorage.showNotificationsPanel : true;

        //NOTIFICATIONS

        var geteInvoiceDocumentsPage = function () {
            var notifyParams = {
                type: "eInvoiceDocuments",
                query: {
                    status: "Inserted"
                }
            };
            if (vm.userSettings.lastLoginDate) {
                notifyParams.query.valueDateGTE = new Date(vm.userSettings.lastLoginDate);
            }

            if (vm.countryCode == 'sl') { //temporarly put first day of the current year
                var date = new Date();
                date.setDate(new Date().getDate() - 365);
                notifyParams.query.valueDateGTE = new Date(date);
            }

            return NotificationCountService.getNotificationCount(notifyParams)
                .then(function (response) {
                    vm.eInvoiceNotifications = +response;
                })
                .catch(function (error) {
                    vm.eInvoiceNotifications = 0;
                    $log.error(error);
                });
        };

        var getRejectedPaymentsPage = function () {
            var notifyParams = {
                type: 'Payments',
                query: {
                    status: "Rejected"
                }
            };

            if (vm.userSettings.lastLoginDate) {
                if (vm.countryCode == 'sl') {
                    notifyParams.query.dueDateGTE = new Date(vm.userSettings.lastLoginDate);
                } else {
                    notifyParams.query.dateCreatedGTE = new Date(vm.userSettings.lastLoginDate);
                }
            }
            return NotificationCountService.getNotificationCount(notifyParams)
                .then(function (response) {
                    vm.rejectedPaymentsNotifications = +response;
                })
                .catch(function (error) {
                    vm.rejectedPaymentsNotifications = 0;
                    $log.error(error);
                });
        };

        vm.dismissNotifications = function () {
            GoogleTagManagerHelperService.pushEvent('Dashboard', 'MessagesNotices', 'Discard');
          vm.showNotificationsPanel = false;
          $sessionStorage.showNotificationsPanel = false;
        };

        vm.pushNotificationsGtmEvent = function (desc) {
            GoogleTagManagerHelperService.pushEvent('Dashboard', 'MessagesNotices', desc);
        };

        vm.downloadTransactionReport = function (transaction) {
            var id = ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == "sl") ? transaction.transactionId : transaction.id;
            TransactionsService.downloadTransactionPdf(id);
        };

      vm.timelineSearchAction = function () {

        if(vm.countryCode === 'sl'){
          vm.timelineFilter.currency = vm.currencySelectObject.symbol;
        }

        vm.getTimelineItemsGrouped(true);


        // if (vm.timelineSearchFilter.descriptionFTS === '') {
        //     vm.showSearchResultWrapper = false;
        //     vm.showDeleteInputBtn = false;
        //     vm.getTimelineItemsGrouped(true);
        // } else {
        //     console.log(vm.pendingPaymentsList.result);
        //     console.log(vm.timelineListGrouped.result);
        //     vm.getTimelineItemsGrouped(true)
        //     vm.getTimelineSearchPage();
        //     vm.showDeleteInputBtn = true;
        // }
      };

        var getUnsignedPaymentsNotifications = function () {
            var notifyParams = {
                type: "Payments",
                query: {
                    status: "Opened"
                }
            }

            if (vm.countryCode == 'sl') {
                notifyParams.query.status = '';
                notifyParams.query.statusList = ['InProcessing', 'WaitingQueue', 'Opened'];
            }

            if (vm.userSettings.lastLoginDate && vm.countryCode != 'sl') {
                notifyParams.query.dateCreatedGTE = new Date(vm.userSettings.lastLoginDate);
            }
            return NotificationCountService.getNotificationCount(notifyParams)
                .then(function (response) {
                    vm.unsignedPaymentsNotifications = +response;
                })
                .catch(function (error) {
                    vm.unsignedPaymentsNotifications = 0;
                    $log.error(error);
                });
        };

        var getNotificationsCount = function () {
            //
            // getGroupPaymentsNotifications();

            var promises = [getRejectedPaymentsPage(), getUnsignedPaymentsNotifications(), geteInvoiceDocumentsPage()];

            // If notifications were loaded once, don't load them again
            if (!$sessionStorage.notificationsLoaded) {
                $q.all(promises).then(function (data) {
                    vm.showNotificationsPanel = true;
                }).catch(function (error) {
                    HelperService.showMessage(error, 'error');
                });
            }

        };

        var loadBannerImages = function () {
            ImagesService.getImages({
                    pageSize: 2,
                    category: 'MarketingMessages'
                })
                .then(function (response) {
                    if (response) {
                        if (response.result[0]) {
                            vm.bannerImageUrl = response.result[0].downloadLink;
                            //vm.bannerImageUrl = "img/hypo/201611-Addiko-12048-e-banking-438x168-papiri-HR-01.png";
                        }
                        if (response.result[1]) {
                            vm.viberImageUrl = response.result[1].downloadLink;
                        }
                    }
                })
                .catch(function (error) {
                    HelperService.showMessage(error, 'error');
                })
        };

        vm.loyaltyPointsResult = {};
        vm.getLoyaltyPointsPage = function () {
            LoyaltyPointsService.getPage({
                    pageSize: 1000
                })
                .then(function (response) {
                    vm.loyaltyPointsResult = response.result[0];
                    $log.debug("loyaltyPointsResult ", vm.loyaltyPointsResult);
                })
                .catch(function (error) {
                    $log.error(error);
                });

        };

        vm.openAddikoClubSl = function () {
            $window.open("http://www.klub.addiko.si/", "_blank");
        };

        //activate Viber service
        // vm.activateViber = function () {
        //
        //     // TEST QR CODE
        //     // AlertService.infoAlert({text: "iVBORw0KGgoAAAANSUhEUgAAAiMAAAIjAQMAAADr5InyAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAGUExURQAAAP///6XZn90AAAAJcEhZcwAADsMAAA7DAcdvqGQAAAIzSURBVHja7dxBcsIwDIVhZVhkyRFyFI7WHo2j5AhdsmBwi2zFUuIydNPG9H8bCHU+ZrrRSDaRRt7STV+nlPMhckpJ5KBXZ3kuKCgoKCgdKIfkM9+VJe8yqPKVlK4iR1XCDRcUFBQUlK6VvE5kLMpN3zpFK4lU5VpuGFBQUFBQXlDJ0bfH0kIs3QQKCgoKyssr072SLAndBAoKCgrKDhQXmwVdyn5ArgEuP5oooaCgoKDsW9nEZkFz6ANcJXkqKCgoKCi7V9LD6H5Ao3ykVfVBQUFBQelRWZeDOVQSqYrldL/eTpRQUFBQUPpTdJGd/MmHgdZpnAtyQUFBQUHpWLGqIHWMlGqZWc6GGmiZKjSjoKCgoPSrWIFw28kSFEs8JlrPHqGgoKCg9Kmk0E2EHYKYQwDFlxwUFBQUlN9Wch9wKp9MdSM4NZ/yoLnWXw+MvptAQUFBQelOcWP+eXs2VOpGcFb0I2sYUFBQUFC6VaxJcHvCWj4uYeJv+aiglG4ioaCgoKD0qtgfNY2J0lC/o50RBQUFBaVrZZ3cQtjMyI2R1hOlwVcSFBQUFJTOlEbC84JS2E620ZN1Ezf5NigoKCgoHSjPPDPu3NxZTmUhCgoKCkrHSpwoOcUdNLLy4bKqJCgoKCgof6u4WdCiuIV6PaOg8N9FQfkfyrkutHNB1iWEs6EoKCgoKN0pLrFAuN8H6OsxrPV7wigoKCgoPSqb6K1jWXmr+wGpVhJTHgQFBQUFZd+KyCcRSzSqLXRnTAAAAABJRU5ErkJggg=="});
        //
        //     // If user already activated Viber, show dialog and ask if he wants new password
        //     if ($rootScope.APP_GLOBAL_SETTINGS.isViberActivated) {
        //         AlertService.confirmationAlert({
        //                 text: "navigation.viberGenerateNewPassword"
        //             })
        //             .then(function (response) {
        //                 if (response) {
        //                     var userId = $rootScope.APP_GLOBAL_SETTINGS.userSettings.id;
        //                     ViberService.resendActivation(userId, {
        //                             deactivateViberUser: false,
        //                             isWebCall: true
        //                         })
        //                         .then(function (response) {
        //                             $rootScope.APP_GLOBAL_SETTINGS.isViberActivated = true;
        //                             AlertService.imageAlert({
        //                                 baseUrl: response.qrCode
        //                             });
        //                         })
        //                         .catch(function (error) {
        //                             HelperService.showMessage(error, 'error');
        //                         });
        //                 }
        //             });
        //     } else {
        //         // User does not have Viber activated, ask to confirm activation process
        //         AlertService.confirmationAlert({
        //                 text: "navigation.viberActivationTxt"
        //             })
        //             .then(function (response) {
        //                 if (response) {
        //                     ViberService.activate({
        //                             phoneNumber: "string"
        //                         })
        //                         .then(function (response) {
        //                             $rootScope.APP_GLOBAL_SETTINGS.isViberActivated = true;
        //                             AlertService.imageAlert({
        //                                 baseUrl: response.qrCode
        //                             });
        //                         })
        //                         .catch(function (error) {
        //                             HelperService.showMessage(error, 'error');
        //                         });
        //                 }
        //             });
        //     }
        //
        //
        // };

        vm.pushGtmLinkEvent = function(linkDesc){
            GoogleTagManagerHelperService.pushEvent('Dashboard', 'ExternalLink', linkDesc);
        };

      // Viber functionality is just for BiH environment
      vm.checkUserViberActivation = function () {
        var stateToGo = $rootScope.APP_GLOBAL_SETTINGS.isViberActivated ? 'viber.deactivate' : 'viber';
        console.log("State to go");
        $state.go(stateToGo);
      };

      vm.downloadMessageAttachment = function (link) {
        if (link.itemList) {
          MessagesService.downloadMessageAttachment(link.itemList.linkAttachment);
        }
      };


        vm.init();

    }
}());
